import { audioPlayer } from "../PhaserExtension";
import * as GameModel from "../models/GameModel";
import StoryCircleState from "./StoryCircleState";
import FlumpObject from "../general/objects/FlumpObject";
import BallSwipeHandler from "../storyCircle/objects/BallSwipeHandler";
import * as DisplaySettings from "../settings/DisplaySettings";
import TimeoutGlow from "../storyCircle/objects/TImeoutGlow";

export default class StoryCircleState2P extends StoryCircleState
{
    setupComponents()
    {
        super.setupComponents();

        this.player.reassign(this.config.assets.playerOne);
        this.player.loop(this.player.keys.idle);
        this.playerTwo = new FlumpObject(this.game, this.config.assets.playerTwo, "storyCircleFlump");
        this.foregroundLayer.add(this.playerTwo);

        if(GameModel.data.turn == "")
        {
            this.player.playOnce(this.player.keys.holdBallEnter);
            this.player.display.paused = true;

            this.playerTwo.playOnce(this.playerTwo.keys.noBallEnter);
            this.playerTwo.display.paused = true;
        }
        else if(GameModel.data.turn == "Player")
        {
            if(GameModel.data.lastPlayer === 1)
            {
                this.player.loop(this.player.keys.holdBall);
            }
            else
            {
                this.playerTwo.loop(this.playerTwo.keys.holdBall);
            }
        }
    }

    onFirstPlay()
    {
        this.playerTwo.visible = false;
        super.onFirstPlay();
    }

    onPlayerTurn()
    {
        audioPlayer.play(this.game, this.config.sounds.pass);
        this.passTimeout = this.game.time.create(false);
        this.passTimeout.loop(Phaser.Timer.SECOND * 12, this.onPassTimeout, this);
        this.passTimeout.start();

        let timeout = new TimeoutGlow(this.game, this.config.assets.timeoutGlow, "storyCircleFlump");
        this.maingroundLayer.add(timeout);
        timeout.visible = false;
        this.timeoutGlows.push(timeout);

        if(GameModel.data.lastPlayer === 1)
        {
            this.swipeHandler = new BallSwipeHandler(this.game, this.player, this.muppets);

            this.playerTwo.targetPosition = new Phaser.Point(DisplaySettings.targetScreenWidth - this.playerTwo.width, this.game.height - 200);
            this.playerTwo.inputEnabled = true;
            this.playerTwo.events.onInputUp.addOnce(this.onMuppetReceivedBall.bind(this, this.swipeHandler.targets.length));
            this.swipeHandler.targets.push(this.playerTwo);

            timeout.x = 950;
            timeout.y = 775;
        }
        else
        {
            this.swipeHandler = new BallSwipeHandler(this.game, this.playerTwo, this.muppets);

            this.player.targetPosition = new Phaser.Point(DisplaySettings.screenWidth - DisplaySettings.targetScreenWidth + this.player.width, this.game.height - 200);
            this.player.inputEnabled = true;
            this.player.events.onInputUp.addOnce(this.onMuppetReceivedBall.bind(this, this.swipeHandler.targets.length));
            this.swipeHandler.targets.push(this.player);

            timeout.x = 370;
            timeout.y = 775;
        }

        for(let i = 0; i < this.muppets.length; i++)
        {
            this.muppets[i].inputEnabled = true;
            this.muppets[i].input.useHandCursor = true;
            this.muppets[i].events.onInputUp.addOnce(this.onMuppetReceivedBall.bind(this, this.muppets[i].id));
        }

        this.swipeHandler.inputEnabled = true;
        this.swipeHandler.onSwipeCompleted.addOnce(this.onMuppetReceivedBall, this);
        this.foregroundLayer.add(this.swipeHandler);
    }

    onMuppetReceivedBall(index)
    {
        this.passTimeout.destroy();
        delete this.passTimeout;

        if(this.timeoutCount > 0)
        {
            GameModel.sendEvent("TOReEnage", "Classroom scene", Date.now() - this.timeoutFiredTime);
        }

        this.swipeHandler.onSwipeCompleted.removeAll();
        this.swipeHandler.inputEnabled = false;
        this.player.inputEnabled = false;
        this.player.events.onInputUp.removeAll();
        this.playerTwo.inputEnabled = false;
        this.playerTwo.events.onInputUp.removeAll();

        for(let i = 0; i < this.muppets.length; i++)
        {
            this.muppets[i].inputEnabled = false;
            this.muppets[i].events.onInputUp.removeAll();
        }

        if(GameModel.data.lastPlayer == 1)
        {
            this.player.loop(this.player.keys.idle);
            this.player.playOnce(this.player.keys.pass, false);
            this.player.onComplete.addOnce(this.player.kill, this.player);
        }
        else
        {
            this.playerTwo.loop(this.playerTwo.keys.idle);
            this.playerTwo.playOnce(this.playerTwo.keys.pass, false);
            this.playerTwo.onComplete.addOnce(this.playerTwo.kill, this.playerTwo);
        }

        if(index == this.swipeHandler.targets.length - 1)
        {
            this.game.time.events.add(Phaser.Timer.SECOND * 0.25, this.onPlayerReceivedBall, this);
        }
        else
        {
            this.player.onComplete.removeAll();
            this.playerTwo.onComplete.removeAll();

            GameModel.data.lastMuppet = index;

            if(GameModel.data.lastPlayer == 1)
            {
                this.passToMuppet(this.player, index);
            }
            else
            {
                this.passToMuppet(this.playerTwo, index);
            }
        }
    }

    passToMuppet(player, index)
    {
        player.loop(player.keys.idle);
        player.playOnce(player.keys.pass, true);
        player.onComplete.addOnce(function()
        {
            this.ball.tweenTo(this.config.assets.muppets[index].receivePosition);
            this.ball.onTweenComplete.addOnce(this.onBallTweenComplete, this);
            player.playOnce(player.keys.noBallEnter, true, true);
        }, this);
    }

    onMuppetPassedBall()
    {
        if(GameModel.data.lastPlayer === 1)
        {
            this.ball.tweenTo(this.config.assets.ball.transform.playerTwoPosition);
        }
        else
        {
            this.ball.tweenTo(this.config.assets.ball.transform.playerOnePosition);
        }

        this.ball.onTweenComplete.addOnce(this.onPlayerReceivedBall, this);
    }

    onPlayerReceivedBall()
    {
        if(GameModel.data.lastPlayer == 1)
        {
            GameModel.data.lastPlayer = 2;

            // The super function will call animations on player, so just swap them
            var tmp = this.player;
            this.player = this.playerTwo;
            this.playerTwo = tmp;
        }
        else
        {
            // Have player one be in front for the explosion effect
            this.foregroundLayer.swapChildren(this.player, this.playerTwo);
            GameModel.data.lastPlayer = 1;

            if(this.player.display.paused)
            {
                this.playerTwo.display.paused = false;
                this.player.keys.receive = this.player.keys.holdBallEnter;
            }
        }

        super.onPlayerReceivedBall();
    }

    onAllChoicesVisible()
    {
        super.onAllChoicesVisible();

        this.playerTwo.playOnce(this.playerTwo.keys.exitScreen, false, true);
        this.playerTwo.onComplete.addOnce(this.playerTwo.destroy, this.playerTwo);
    }
}
